var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.componentName,{tag:"component",attrs:{"data":_vm.data,"isPreview":_vm.isPreview,"isShow":_vm.isShow,"isRefresh":_vm.isRefresh}})}
var staticRenderFns = []

export { render, staticRenderFns }